module.exports = __webpack_public_path__ + "static/media/red-alert-triangle.fa8342b6.svg";